import { render } from "./AcademicLayout.vue?vue&type=template&id=528de7f3&scoped=true"
import script from "./AcademicLayout.vue?vue&type=script&lang=js"
export * from "./AcademicLayout.vue?vue&type=script&lang=js"

import "./AcademicLayout.vue?vue&type=style&index=0&id=528de7f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528de7f3"]])

export default __exports__